import React from "react";
import { Button, Typography, Row, Col, Space, Card } from "antd";
import {
  HomeOutlined,
  ArrowLeftOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const NotFound404 = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: "100vh",
        background: "linear-gradient(to right, #fbc2eb, #a6c1ee)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 24,
        borderRadius: 16,
      }}
    >
      <Card
        style={{
          maxWidth: 800,
          width: "100%",
          textAlign: "center",
          borderRadius: 16,
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
          background: "rgba(255, 255, 255, 0.95)",
        }}
      >
        <Title level={1}>404</Title>
        <Text type="secondary" style={{ fontSize: 18 }}>
          PAGE NOT FOUND 😢
        </Text>

        <div style={{ marginTop: 40 }}>
          <div
            style={{
              display: "inline-grid",
              gridTemplateColumns: "repeat(2, 100px)",
              gap: "12px",
              padding: "24px",
              background: "#fafafa",
              borderRadius: 16,
              boxShadow: "inset 0 0 12px #ddd",
              marginBottom: 30,
            }}
          >
            <button onClick={() => navigate(1)} style={keyboardKeyStyle}>
              🚀
              <br />
              Go
            </button>
            <button onClick={() => navigate(-1)} style={keyboardKeyStyle}>
              🔙
              <br />
              Back
            </button>
            <button onClick={() => navigate("/")} style={keyboardKeyStyle}>
              🏠
              <br />
              Home
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                ...keyboardKeyStyle,
                backgroundColor: "#7c3aed",
                color: "#fff",
                fontWeight: 600,
              }}
            >
              ⏎<br />
              <span style={{ fontSize: 12 }}>Enter</span>
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
};

const keyboardKeyStyle = {
  width: "100px",
  height: "100px",
  background: "#fff",
  border: "2px solid #ddd",
  borderRadius: "12px",
  boxShadow: "2px 4px 10px rgba(0,0,0,0.15)",
  fontSize: 18,
  fontWeight: "bold",
  cursor: "pointer",
  transition: "all 0.2s ease",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  lineHeight: 1.2,
};

export default NotFound404;
